import { Box, Button, ScrollArea } from '@mantine/core';
import { EventsList } from 'src/meetings/components/EventsList';
import { EventsLoadingBanner } from 'src/meetings/components/EventsLoadingBanner';
import { UpcomingEventCard } from 'src/meetings/components/UpcomingEventCard';
import type { CalendarEvent } from 'src/meetings/models';

type Props = {
  events: CalendarEvent[];

  selectedEventId: string | null;
  onEventSelect: (eventId: string | null) => void;
  onRefetchNeeded: () => void;
  hasNextPage: boolean;
  fetchNextPage: () => void;
  isFetchingNextPage: boolean;
  connecting?: boolean;
};

export const UpcomingEventsList = ({
  events,
  onEventSelect,
  selectedEventId,
  onRefetchNeeded,
  hasNextPage,
  fetchNextPage,
  isFetchingNextPage,
  connecting,
}: Props) => {
  return (
    <>
      <Box style={{ flex: 1, minHeight: 0 }}>
        <ScrollArea h="100%" px="lg">
          <EventsList
            events={events}
            emptyMessage={
              connecting
                ? undefined
                : 'Schedule a meeting with the client to see it here or connect more accounts.'
            }
            renderCard={event => (
              <UpcomingEventCard
                event={event}
                onClick={() => onEventSelect(event.id)}
                isSelected={selectedEventId === event.id}
                onRemove={() => {
                  if (event.id === selectedEventId) {
                    onEventSelect(null);
                  }
                  onRefetchNeeded();
                }}
              />
            )}
          />
          <EventsLoadingBanner />
          {hasNextPage && (
            <Box ta="center" mt="md" mb="md">
              <Button
                variant="outline"
                onClick={() => fetchNextPage()}
                disabled={isFetchingNextPage}
              >
                {isFetchingNextPage ? 'Loading more...' : 'Load More'}
              </Button>
            </Box>
          )}
        </ScrollArea>
      </Box>
    </>
  );
};
